import http from '@/assets/common/http';
// 获取未检测列表
export function queryNotCheck(data) {
  const params = {
    SERVICE_ID: '10054',
    OTYPE: 1,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// 提交检测数据
export function submitCheckFun(data) {
  const params = {
    SERVICE_ID: '10054',
    OTYPE: 2,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// 获取已提交数据
export function queryhaveCheck(data) {
  const params = {
    SERVICE_ID: '10054',
    OTYPE: 3,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// 删除已提交数据
export function deleteFun(data) {
  const params = {
    SERVICE_ID: '10054',
    OTYPE: 4,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// 修改已提交数据
export function editRecordFun(data) {
  const params = {
    SERVICE_ID: '10054',
    OTYPE: 5,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/checkDoc.js